import { render, staticRenderFns } from "./ColorPalettePicker.vue?vue&type=template&id=460afb44&scoped=true"
import script from "./ColorPalettePicker.vue?vue&type=script&lang=js"
export * from "./ColorPalettePicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPalettePicker.vue?vue&type=style&index=0&id=460afb44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460afb44",
  null
  
)

export default component.exports